
import ComponentInitializeDispatcher from '@/packages/_utils/Mixins/ComponentInitializeDispatcher';
import Logger from '../../_utils/common/Logger';
import { Language, LanguageSwitchComponent } from './LanguageSwitch';

/*
 * TODO: We are not using the mixin here because this module does not behave as the others do.
 *  It seems that it not meant to be used as a webcomponent and it does not receive the
 * normal datajson as a string but as an object. We have to decide as a team what shall be
 * done in these types of situations. For now it remais without the mixin so it can work properly.
 *
 * */
export default (ComponentInitializeDispatcher as LanguageSwitchComponent).extend({
  name: 'LanguageSwitch',
  props: {
    languageSwitch: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      urlList: [],
    };
  },
  created() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.delete('token');
    const queryParameters = `${params.toString()}`;
    const path = window.location.pathname || '';
    const activeLanguage = this.languageSwitch.find((language: Language) => language.isCurrent);

    if (activeLanguage) {
      const currentLangCode = activeLanguage.code;
      const pathParameters = path.split(activeLanguage.url)[1] || '';

      /**
       * Parses any extra parameters in the url to the correct language
       */
      this.urlList = this.languageSwitch.map(languageItem => {
        const item = languageItem;
        let parsedPathToLanguage = pathParameters;

        if (pathParameters) {
          parsedPathToLanguage = pathParameters.replace(
            new RegExp(currentLangCode, 'gi'),
            languageItem.code.toLowerCase(),
          );
        }

        return {
          ...item,
          url: `${item.url}${parsedPathToLanguage}${queryParameters.length ? '?' + queryParameters : ''}`,
        };
      });
    } else {
      Logger.warn('No active language provided');
    }
  },
});
